import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import 'date-fns';
// import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import Select from "react-select";
import axios from "axios";
import "./schedule.css";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slider from "@material-ui/core/Slider";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { StoreContext } from "../../../store/Provider";
import { HOST_URL, basename } from "../../../config";
import MainLayout from "../../common/Layout/MainLayout";
import TextField from "@mui/material/TextField";
// import MobileDatePicker from "@mui/lab/MobileDatePicker";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import routeConstant from "../../../route/compoent/routeConstant";

const AirbnbSlider = withStyles({
  root: {
    color: "#147ad6",
    height: 3,
    padding: "13px 0",
  },
  thumb: {
    height: 27,
    width: 27,
    backgroundColor: "#122D76",
    border: "1px solid #122D76",
    marginTop: -12,
    marginLeft: -13,
    boxShadow: "#ebebeb 0 2px 2px",
    "&:focus, &:hover, &$active": {
      boxShadow: "#ccc 0 2px 3px 1px",
    },
    "& .bar": {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  track: {
    height: 3,
  },
  rail: {
    color: "#122d761a",
    opacity: 1,
    height: 3,
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <img src={`/${basename}/Assets/Images/arrowLeft.svg`} />
      <img src={`/${basename}/Assets/Images/arrowRight.svg`} />
      {/* <span className="bar" />
            <span className="bar" />
            <span className="bar" /> */}
    </span>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Schedule = () => {
  const [value, setValue] = useState("A");
  const [valuetoset, setValuetoset] = useState("Latest Arrival Date");
  const [valueSlider, setValueSlider] = useState(2);
  const [countryObject, setCountryObject] = useState([]);
  const [originportObject, setOriginPortObject] = useState([]);
  const [destportObject, setDestPortObject] = useState([]);
  const [sealineslist, setSealineslist] = useState([]);
  const [originCountry, setOriginCountry] = useState("");
  const [originPort, setOriginPort] = useState("");
  const [destinationCountry, setDestinationCountry] = useState("");
  const [destinationPort, setDestinationPort] = useState("");
  const [sealines, setSealines] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState({
    country: false,
    originPort: false,
    destinationPort: false,
    sealine: false,
  });
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const context = useContext(StoreContext);
  const navigate = useNavigate();

  useEffect(() => {
    getCountry();
    getSealines();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const resetSchedule = () => {
    setValue("D");
    // setSealineslist([]);
    // setCountryObject([]);
    setValueSlider(2);
    setOriginPortObject([]);
    setDestPortObject([]);
    setOriginCountry("");
    setOriginPort("");
    setDestinationCountry("");
    setDestinationPort("");
    setSealines("");
    setSelectedDate(null);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSliderChange = (event, newValue) => {
    setValueSlider(newValue);
  };

  const getCountry = () => {
    setApiLoading({ ...apiLoading, country: true });
    const URL = `${HOST_URL}api/GetAllCountries`;
    axios
      .get(URL)
      .then((res) => {
        setCountryObject(res.data.countries);
        setApiLoading({ ...apiLoading, country: false });
      })
      .catch((err) => {
        console.log(err);
        setApiLoading({ ...apiLoading, country: false });
      });
  };

  const getPortOrigin = (props) => {
    setOriginPortObject([]);
    setApiLoading({ ...apiLoading, originPort: true });
    if (props) {
      const URL = `${HOST_URL}api/GetPorts?country_code=${props.value}`;
      axios
        .get(URL)
        .then((res) => {
          setOriginPortObject(res.data.ports);
          setApiLoading({ ...apiLoading, originPort: false });
        })
        .catch((err) => {
          console.log(err);
          setApiLoading({ ...apiLoading, originPort: false });
        });
    }
  };

  const getPortDest = (props) => {
    setDestPortObject([]);
    setApiLoading({ ...apiLoading, destinationPort: true });
    if (props) {
      const URL = `${HOST_URL}api/GetPorts?country_code=${props.value}`;
      axios
        .get(URL)
        .then((res) => {
          setDestPortObject(res.data.ports);
          setApiLoading({ ...apiLoading, destinationPort: false });
        })
        .catch((err) => {
          console.log(err);
          setApiLoading({ ...apiLoading, destinationPort: false });
        });
    }
  };

  const getSealines = () => {
    setApiLoading({ ...apiLoading, sealine: true });
    const URL = `${HOST_URL}api/GetAllSeaLines`;
    axios
      .get(URL)
      .then((res) => {
        setSealineslist(res.data.lines);
        setApiLoading({ ...apiLoading, sealine: false });
      })
      .catch((err) => {
        console.log(err);
        setApiLoading({ ...apiLoading, sealine: false });
      });
  };

  const getSearchResult = () => {
    // resetSchedule();
    if (originCountry === "") {
      setOpen(true);
      setAlertText("Please select Origin Country.");
    } else if (originPort.value === undefined) {
      setOpen(true);
      setAlertText("Please select Origin Port.");
    } else if (destinationCountry === "") {
      setOpen(true);
      setAlertText("Please select Destination Country.");
    } else if (destinationPort.value === undefined) {
      setOpen(true);
      setAlertText("Please select Destination Port.");
    } else if (selectedDate === null) {
      setOpen(true);
      setAlertText("Please select Date.");
    } else if (sealines.value === undefined) {
      setOpen(true);
      setAlertText("Please select Sealine.");
    } else if (valueSlider === 0) {
      setOpen(true);
      setAlertText("Please select weeks.");
    } else if (originPort.value === destinationPort.value) {
      setOpen(true);
      setAlertText("Please select different Destination.");
    } else {
      setLoading(true);
      const startDate = moment(selectedDate).format("DD-MM-YYYY");
      if (value === "A") {
        setValuetoset("Latest Arrival Date");
      } else if (value === "D") {
        setValuetoset("Earlier Departure Date");
      }
      context.setRequestQuote({
        origincountry: originCountry.label,
        OriginPort: originPort.value,
        destinationCountry: destinationCountry.label,
        destinationPort: destinationPort.value,
        availvableDirection: valuetoset,
        dateShip: startDate,
        weekAhead: valueSlider,
      });
      const URL = `${HOST_URL}api/GetSearchResults?origin_code=${originPort.value}&destination_code=${destinationPort.value}&start_date=${startDate}&weeks_ahead=${valueSlider}&direction_A_or_D=${value}&sac_codes=${sealines.value}`;
      axios
        .post(URL)
        .then((res) => {
          if (res.data.shipping_lines) {
            context.setSearchResult(res.data.shipping_lines);
          }
          setLoading(false);
          navigate(routeConstant.SEARCH_RESULT);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const countryObjectOption = countryObject.map((countrylist) => {
    return {
      value: countrylist.key,
      label: `${countrylist.name} (${countrylist.key})`,
    };
  });

  const originportObjectOption = originportObject.map((originportlist) => {
    return {
      value: originportlist.key,
      label: `${originportlist.name} (${originportlist.key})`,
    };
  });

  const destinationportObjectOption = destportObject.map(
    (destinationportlist) => {
      return {
        value: destinationportlist.key,
        label: `${destinationportlist.name} (${destinationportlist.key})`,
      };
    }
  );

  const seaLinesObject = sealineslist.map((sealineslist) => {
    return {
      value: sealineslist.key,
      label: `${sealineslist.name} (${sealineslist.key})`,
    };
  });
  const newAllOption = {
    value: "",
    label: "ALL",
  };
  const seaLinesObjectOption = [newAllOption].concat(seaLinesObject);
  console.log("countryObjectOption", countryObjectOption);
  return (
    <div className="scheduleComp">
      <div className="scheduleheader">
        <h6>Ship your Cargo!</h6>
      </div>
      <div className="schedulebody">
        <div className="schedulebodyInner">
          <div className="container">
            <div className="row my-3">
              <div className="col-md-4 col-12 px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 scheduleCompSelect">
                <div className="scheduleCompSelectInner">
                  <label className="form-label">Origin</label>
                  <Select
                    className="reactSelect"
                    isLoading={apiLoading.country}
                    placeholder="Select Country"
                    options={countryObjectOption}
                    value={originCountry}
                    onChange={(selectedOption) => {
                      setOriginCountry(selectedOption);
                      setOriginPort("");
                    }}
                  />
                  <div
                    className="reactSelectParent"
                    onClick={() => getPortOrigin(originCountry)}
                  >
                    <Select
                      className="reactSelect"
                      isLoading={
                        originCountry.value ? apiLoading.originPort : null
                      }
                      placeholder="Select Port"
                      options={originportObjectOption}
                      value={originPort}
                      onChange={(selectedOption) =>
                        setOriginPort(selectedOption)
                      }
                    />
                  </div>
                </div>
                <div className="scheduleCompSelectInner">
                  <label className="form-label">Destination</label>
                  <Select
                    className="reactSelect"
                    isLoading={apiLoading.country}
                    placeholder="Select Country"
                    options={countryObjectOption}
                    value={destinationCountry}
                    onChange={(selectedOption) => {
                      setDestinationCountry(selectedOption);
                      setDestinationPort("");
                    }}
                  />
                  <div
                    className="reactSelectParent"
                    onClick={() => getPortDest(destinationCountry)}
                  >
                    <Select
                      className="reactSelect"
                      isLoading={
                        destinationCountry.value
                          ? apiLoading.destinationPort
                          : null
                      }
                      placeholder="Select Port"
                      options={destinationportObjectOption}
                      value={destinationPort}
                      onChange={(selectedOption) =>
                        setDestinationPort(selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 scheduleCompSelect">
                <div className="scheduleCompSelectInner dateShipmentSelection">
                  <label className="form-label">Date to Ship</label>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      value={selectedDate}
                      onChange={handleDateChange}
                      minDate={new Date()}
                      clearable
                      id="shipDate"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField
                          style={{
                            color: "hsl(0, 0%, 50%)",
                            fontSize: "1rem",
                            fontWeight: "400",
                          }}
                          placeholder="Select Date"
                          variant="filled"
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <DatePicker minDate={new Date()} clearable id="shipDate" placeholder="dd/mm/yyyy" format="dd/MM/yyyy" value={selectedDate} onChange={handleDateChange} />
                                        </MuiPickersUtilsProvider> */}
                </div>
                <div className="scheduleCompSelectInner">
                  <label className="form-label">Sealine</label>
                  <Select
                    className="reactSelect"
                    isLoading={apiLoading.sealine}
                    placeholder="Select Sealine"
                    options={seaLinesObjectOption}
                    value={sealines}
                    onChange={(selectedOption) => setSealines(selectedOption)}
                  />
                </div>
              </div>
              <div className="col-md-4 col-12 px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 scheduleCompSelect">
                <div className="scheduleCompSelectInner">
                  <label className="form-label">Available Direction</label>
                  <RadioGroup
                    className="selectDirection"
                    name="availableDirection"
                    value={value}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="D"
                      control={<Radio color="primary" />}
                      label="Earlier Departure Date"
                    />
                    <FormControlLabel
                      value="A"
                      control={<Radio color="primary" />}
                      label="Latest Arrival Date"
                    />
                  </RadioGroup>
                </div>
                <div className="scheduleCompSelectInner">
                  <label className="form-label">Weeks Ahead</label>
                  <AirbnbSlider
                    onChange={handleSliderChange}
                    value={valueSlider}
                    ThumbComponent={AirbnbThumbComponent}
                    defaultValue={[2]}
                    max={10}
                  />
                  {valueSlider > 0 ? (
                    <div className="weekShow">{valueSlider} weeks</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="shipmentheaderbuttongroups">
              <Button
                variant="contained"
                className="shipmentheaderbutton"
                onClick={resetSchedule}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                className="shipmentheaderbutton selected"
                onClick={getSearchResult}
              >
                &nbsp;
                {loading ? (
                  <CircularProgress size="1rem" color="inherit" />
                ) : (
                  "Search"
                )}
                &nbsp;
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity="error" onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Schedule;
